module.exports = __webpack_public_path__ + "img/IMG_9808.1fcab306.jpeg";